import { FC } from 'react';
import styled, { Box } from '@xstyled/styled-components';
import { SystemProps } from '@xstyled/system';

export const Centered: FC<SystemProps> = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: center;
`;
